import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        account: localStorage.getItem('state') ? JSON.parse(localStorage.getItem('state')).account : "",
    },
    mutations: {
        // 写入用户账户
        SET_ACCOUNT(state, v) {
            state.account = v
        },
    },
    actions: {}
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js